import React from 'react'

import { Button, ConfirmationDialog as ConfirmationDialogComponent } from '../../components'

export interface IConfirmationDialog {
  state: any
  onCancel: () => void
  onAction: () => void
}

export function ConfirmationDialog({ onCancel, onAction, state }: IConfirmationDialog) {
  return (
    <ConfirmationDialogComponent
      state={state}
      aria-label="Remove all drawings?"
      title="Remove all drawings?"
      actions={
        <>
          <Button data-testid="confirmation-dialog-cancel" onClick={onCancel}>
            Cancel
          </Button>
          <Button data-testid="confirmation-dialog-delete" onClick={onAction} theme="red">
            Delete
          </Button>
        </>
      }
    >
      Do you really want to remove all drawings? This action only affects the current page and doesn't modify saved
      ideas.
    </ConfirmationDialogComponent>
  )
}
